import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RedirectToHomeDigest } from '../Navigation'
import { InstantOfferButton } from '../AvmModule/InstantOffer/InstantOfferButton'
import { Page, BotHeadSpin } from '../..'
import { OverlayQuestionsFooter } from '../Routing'
import { SlideOnMount } from '../Animations'
import {
  selectShouldRenderMarketPanel,
  selectShouldRenderEquitySmartSearchFeatures
} from '../../../store/selectors/display'
import { selectHomeownerMarketLoading } from '../../../store/selectors/marketRecord'
import { useCreateHomeClientEventOnce } from '../../../hooks'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import MarketSpotlightText from './MarketSpotlightText'
import { MarketSpotlightChart } from './MarketSpotlightChart'
import MarketOverview from './MarketOverview'
import { MarketFacts } from './MarketFacts'
import MarketCash from './MarketCash'
import MarketSpotlightVideo from './MarketSpotlightVideo'
import { EquitySmartSearchTable } from './EquitySmartSearchTable'
import { MarketSimilarHomes } from './MarketSimilarHomes'
import ThinkingOfSelling from './ThinkingOfSelling'
import { selectHomebotListingsFeatureEnabled } from '../../../store/selectors/customerProfile'
import { ClientEventName } from '../../../api/gqlaxy/gql/generated/graphql'

import styles from './MarketSpotlight.module.scss'

const MARKET_TEMP_CHART_ID = 'market-temp-chart'

export const MarketSpotlight = () => {
  const createViewedMarketClientEvent = useCreateHomeClientEventOnce({ eventName: ClientEventName.ViewedMarketPanel })

  const showListings = useSelector(selectHomebotListingsFeatureEnabled)

  const shouldRender = useSelector(selectShouldRenderMarketPanel)
  const showEquitySmartSearchFeatures = useSelector(selectShouldRenderEquitySmartSearchFeatures)

  const loading = useSelector(selectHomeownerMarketLoading)

  useEffect(() => {
    createViewedMarketClientEvent()
  }, [])

  if (!shouldRender) {
    return <RedirectToHomeDigest />
  }

  return (
    <Page>
      <Page.Body className={styles.body} dataQa='market-spotlight'>
        {loading ? (
          <BotHeadSpin panelSpacing />
        ) : (
          <>
            <SlideOnMount>
              <MarketSpotlightText withDescription className={styles.header} />
            </SlideOnMount>
            <MarketSpotlightVideo />
            <InstantOfferButton className={styles.instantOfferBtn} />
            <SlideOnMount>
              <MarketSpotlightChart placementId={MARKET_TEMP_CHART_ID} className={styles.chartWrapper} />
            </SlideOnMount>
            <SlideOnMount>
              {showListings && <MarketSimilarHomes />}
              <div className={styles.marketInfo}>
                <MarketFacts />
                <MarketOverview />
              </div>
            </SlideOnMount>
            <SlideOnMount>
              <ThinkingOfSelling />
            </SlideOnMount>
            <SlideOnMount>
              {showEquitySmartSearchFeatures && !showListings && <EquitySmartSearchTable />}
              <MarketCash />
            </SlideOnMount>
          </>
        )}
        <Page.Disclaimer />
      </Page.Body>
      <Page.Footer>
        <OverlayQuestionsFooter
          topic={[
            CUSTOMER_MESSAGES.SHOULD_SELL_MARKET.topic,
            CUSTOMER_MESSAGES.HOMEOWNER_MARKET.topic,
            CUSTOMER_MESSAGES.HOMEOWNER_MARKET.topic // topic for the custom "Ask a question..." DM
          ]}
          questions={[CUSTOMER_MESSAGES.SHOULD_SELL_MARKET.message, CUSTOMER_MESSAGES.HOMEOWNER_MARKET.message]}
          topicKey={[
            CUSTOMER_MESSAGES.SHOULD_SELL_MARKET.topicKey,
            CUSTOMER_MESSAGES.HOMEOWNER_MARKET.topicKey,
            CUSTOMER_MESSAGES.HOMEOWNER_MARKET.topicKey // topicKey for the custom "Ask a question..." DM
          ]}
          placeholder
          disableCospo
        />
      </Page.Footer>
    </Page>
  )
}
